module.exports = __webpack_public_path__ + "static/media/3s_bis_06.cc757984.jpg";